import { useMutation, useQueryClient } from "@tanstack/react-query";
import { adeclaBackAPI } from "api/helper";
import { PERSONNUMMER_STATUS_KEY } from "./useGetPersonnummerStatus";

export interface PersonnummerSubmission {
  /** 12 siffror utan bindestreck, ÅÅÅÅMMDDNNNN. */
  personnummer: string;
  firstName: string;
  lastName: string;
  email: string;
}

/**
 * Skickar en rad per person till rapportgeneratorn (ADE-50), i tur och ordning.
 *
 * Bara formulärets fyra fält skickas, och ingen x-fa-active-contact: vem som
 * skickar och vilken linked contact raden hör till tar API:t ur FA-token.
 *
 * Ett misslyckat anrop blir ett nytt Error utan det ursprungliga felet:
 * axios-felet bär request-bodyn, alltså personnumret, och react-query skriver
 * ut misslyckade mutationer i konsolen.
 */
export const useSubmitPersonnummer = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, isLoading, isError } = useMutation<
    void,
    Error,
    PersonnummerSubmission[]
  >(
    async (persons) => {
      for (const person of persons) {
        try {
          await adeclaBackAPI<{ ok: true }, PersonnummerSubmission>({
            path: "personnummer",
            method: "POST",
            body: person,
          });
        } catch {
          throw new Error("Kunde inte skicka personnummer");
        }
      }
    },
    {
      onSuccess: () => queryClient.invalidateQueries(PERSONNUMMER_STATUS_KEY),
    }
  );

  return { submitPersonnummer: mutateAsync, isLoading, isError };
};
